import { render } from "./GetMemberShip.vue?vue&type=template&id=6d6b1ef0&scoped=true"
import script from "./GetMemberShip.vue?vue&type=script&lang=js"
export * from "./GetMemberShip.vue?vue&type=script&lang=js"

import "./GetMemberShip.vue?vue&type=style&index=0&id=6d6b1ef0&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6b1ef0"]])

export default __exports__